// vue 全局过滤器: 七牛图片裁剪，生成不小于minwidth，minheight的缩略图，并裁剪为width×height
export function imgCrop  (url, minwidth, minheight, width, height) {
    return url + '?imageMogr2/thumbnail/!' + minwidth + 'x' + minheight + 'r/gravity/Center/crop/' + width + 'x' + height;
}